import { useState } from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { SecondaryButton, TransparentButton } from 'common/button'
import { P } from 'common/typography'
import { useBadge } from 'querys/course'
import { MdClose } from 'react-icons/md'
import { useLesson } from 'querys/lesson'
import { usePaymentStatus } from 'querys/payment'

const FreeClassBannerStyled = styled.div`
  font: var(--regular);
  /* padding: 16px; */
  .free-banner-container {
    padding: 16px;
    border: 1px solid var(--baseSecondary);
    border-radius: 8px;
    background: var(--neutral100);
  }
  .free-class-info {
    display: flex;
    margin-bottom: 16px;
    color: var(--white);
    p {
      margin: 0 8px;
    }
    svg {
      min-width: 28px;
    }
    ${TransparentButton} {
      color: inherit;
      align-items: flex-start;
    }
  }
  @media(min-width: 1024px) {
    padding: 0;
    .free-banner-container {
      position: relative;
      display: flex;
      align-items: center;
      border-radius: 0;
    }
    .badge {
      width: 64px;
      height: 64px;
    }
    .free-class-info {
      margin: 0;
      align-items: center;
      p {
        margin: 0 32px 0 16px;
      }
    }
    svg {
      position: absolute;
      right: 16px;
      top: 0;
      bottom: 0;
      margin: auto 0;
    }
  }
`

function FreeClassBanner() {
  const { data: badgeInfo } = useBadge()
  const { data: { has_access: hasCourseAccess }, isStale: paymentStale } = usePaymentStatus()
  const {
    data: {
      has_access: hasLessonAccess,
      course: { title, slug },
    },
    isStale: lessonStale,
  } = useLesson()
  const [close, setClose] = useState(false)
  const freeCourses = ['desarrollo-web', 'figma-frontends']
  const isFree = freeCourses.includes(slug)

  if (paymentStale || lessonStale) return null

  if (hasCourseAccess || !hasLessonAccess || close) return null

  const image = badgeInfo?.badge?.image
  const description = badgeInfo?.badge?.description

  return (
    <FreeClassBannerStyled>
      <div className="free-banner-container">
        <div className="free-class-info">
          <img className="badge" src={image} alt={description} width="40" height="40" />
          <P>
            Estas viendo una clase gratuita del
            {' '}
            <b>{title}</b>
          </P>
          <TransparentButton onClick={() => setClose(true)}>
            <MdClose size="28" />
          </TransparentButton>
        </div>
        {isFree ? (
          <Link href={`/cursos/${slug}#promo-video`} passHref>
            <SecondaryButton height="48" fullWidth fitContent>
              Únete al curso
            </SecondaryButton>
          </Link>
        ) : (
          <Link href={`/comprar/cursos/${slug}`} passHref>
            <SecondaryButton fullWidth fitContent id="buy-from-free-class">
              Comprar curso
            </SecondaryButton>
          </Link>
        )}
      </div>
    </FreeClassBannerStyled>
  )
}

export default FreeClassBanner
